
module.directive("bubble", function() {
    return {
        restrict: 'E',
        template: [
            "<div class='bubble' ng-style='{transform: scale}'></div>",
            "<div class='percent'>{{ percent }}%</div>",
        ].join(''),
        scope: {numerator: '=', denominator: '='},
        link: function(scope, element, attrs) {
            scope.$watchGroup(['numerator', 'denominator'], function(values) {
                var num = values[0], denom = values[1],
                    percent = num && denom ? num / denom : 0,
                    scale = Math.max(.07, Math.min(1, Math.sqrt(percent)));

                if (percent === 0) {
                    scope.percent = 0;
                    scope.scale = "scale(0)";
                } else {
                    scope.percent = percent < .01 ? '<1' : Math.round(percent * 100);
                    scope.scale = "scale(" + scale + ")";
                }
            });
        }
    };
});


module.directive("bubbles", function($parse) {
    return {
        restrict: 'E',
        templateUrl: 'util/widgets/bubbles',
        scope: {
            options: '=',
            data: '=',
            selected: '=',
            onChange: '&',
        },
        link: function(scope, element, attrs) {
            var canAssign = !!($parse(attrs.selected).assign)

            scope.click = function(option) {
                if (canAssign) scope.selected = option;
                scope.onChange({value: option});
            }

            scope.percent = function(option, alter) {
                alter = alter || angular.identity;
                var value = alter(scope.data && scope.data[option]),
                    total = alter(scope.data && scope.data.total);
                return value && total ? value / total : 0;
            }

            scope.scale = function(option) {
                var percent = Math.sqrt(scope.percent(option)),
                    scale = percent === 0 ? .025 : Math.max(.05, Math.min(1, percent));
                return {
                    transform: 'scale(' + scale +  ')',
                };
            };
        },
    };
});
